import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-casino-provider',
  templateUrl: './casino-provider.component.html',
  styleUrls: ['./casino-provider.component.scss']
})
export class CasinoProviderComponent {

  providers = [
    {
      name: 'EZUGI',
      image: 'assets/provider/ezugi.jpeg'
    },
    {
      name: 'AURA',
      image: 'assets/provider/aura.jpeg'
    },
    {
      name: 'SPRIBE',
      image: 'assets/provider/spribe.jpeg'
    },
    {
      name: 'MAC88',
      image: 'assets/provider/mac88.jpeg'
    }
  ];

  constructor(private router: Router) { }
  openProvider(provider: any): void {

    if (!provider?.name) {
      return;
    }

    const providerName =
      String(provider.name)
        .trim()
        .toUpperCase();

    sessionStorage.setItem(
      'selectedCasinoProvider',
      providerName
    );

    this.router.navigate(
      ['/tabgames', '6'],
      {
        queryParams: {
          provider: providerName
        }
      }
    );
  }
}